import { fetchCustomersMembers, fetchCustomersMembersSchema } from '../api/customers';

const state = {
    schema: {},
    users: [],
    authMember: {},
};

const getters = {};

const mutations = {
    SET_SCHEMA(state, schema = {}) {
        state.schema = Object.freeze(schema);
    },
    SET_AUTH_MEMBER(state, user) {
        state.authMember = user;
    },
};

const actions = {
    async fetchSchema({ commit }) {
        commit('SET_SCHEMA', await fetchCustomersMembersSchema());
    },
    async fetchAuthMember({ commit }, id) {
        const params = { user_id: id };
        const { results } = await fetchCustomersMembers(params);
        commit('SET_AUTH_MEMBER', results[0] || {});
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
